import type { DecryptHighlight } from "../hooks/usePollInsights";

interface SpotlightProps {
  highlight: DecryptHighlight | null;
}

export function DecryptSpotlight({ highlight }: SpotlightProps) {
  if (!highlight) {
    return (
      <div className="spotlight-card empty">
        <div className="spotlight-aurora" />
        <div className="spotlight-content">
          <p className="spotlight-kicker">Decryptions queued</p>
          <h3>Waiting for the next winner</h3>
          <p className="spotlight-subtext">
            Once votes are decrypted, the winning project will burst into view with immersive
            highlights and confetti-inspired glow.
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="spotlight-card">
      <div className="spotlight-aurora" />
      <div className="spotlight-content">
        <p className="spotlight-kicker">Winner unlocked</p>
        <h3>{highlight.title}</h3>
        <p className="spotlight-winner">
          {highlight.winner} · {highlight.votes} votes
        </p>
        <p className="spotlight-subtext">
          {Math.round(highlight.share * 100)}% of the decrypted tally · Poll #{highlight.voteId + 1}
        </p>
        <div className="spotlight-footer">
          <span>Signed off at {highlight.timestamp}</span>
          <span>{highlight.totalVotes} ballots tallied</span>
        </div>
      </div>
    </div>
  );
}


